module.exports = __webpack_public_path__ + "static/media/no-membercard.7de66adf.png";